import Axios from "axios";

export const getIndicators = data => {
  let { uen } = data;

  const requestUrl = `/data/indicator`;

  return Axios.get(requestUrl, { params: { organizationUen: uen } });
};

export const getSupportedIndicatorVars = data => {
  let { fiduciaryUen, token } = data;

  const requestUrl = `/data/indicator/formula-supported-vars`;

  return Axios.get(requestUrl, {
    params: { organizationUen: fiduciaryUen, access_token: token }
  });
};

export const defineIndicator = data => {
  const requestUrl = `/data/indicator`;
  let { uen, labels, formula, unit } = data;

  let formData = new FormData();
  formData.append("organizationUen", uen);
  formData.append("labels", JSON.stringify(labels));
  formData.append("formula", formula);
  formData.append("unit", unit);

  return Axios.post(requestUrl, formData);
};

export const updateIndicator = data => {
  const requestUrl = `/data/indicator/update`;
  let { uen, id, labels, formula, unit } = data;
  let formData = new FormData();
  formData.append("organizationUen", uen);
  formData.append("id", id);
  formData.append("labels", JSON.stringify(labels));
  formData.append("formula", formula);
  formData.append("unit", unit);
  return Axios.post(requestUrl, formData);
};

export const deleteIndicator = data => {
  const requestUrl = `/data/indicator/delete`;
  let { uen, id } = data;
  let formData = new FormData();
  formData.append("organizationUen", uen);
  formData.append("id", id);
  return Axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/indicator.js